import Typography from "@mui/material/Typography";
import React from "react";

export const WORDS_NOT_IN_USE_FRENCH_MESSAGE =
    "No French words are left here — use Bedrock AI below to find words.";

/** Shown instead of the words-not-in-use chip list for French puzzles. */
export default function WordsNotInUseFrenchNotice() {
    return (
        <Typography variant="body2" color="error" sx={{ py: 1, fontWeight: 500 }}>
            {WORDS_NOT_IN_USE_FRENCH_MESSAGE}
        </Typography>
    );
}
